import useDashboardAssets, { AssetRowData } from './useDashboardAssets'

export type { AssetRowData }
export default useDashboardAssets
